module.exports = __webpack_public_path__ + "41d1c380fcfd69dc6a5f707a336f123b.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo_cabin_w.svg
// module id = 213
// module chunks = 0